export default __webpack_public_path__ + "static/media/walletPaymentScreen.047fd918.svg";